import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CardStack } from "@shared/models/card-stack"
import type { Planbook } from "@shared/models/planbook"
import copyLessonAction from "cc-frontend/lib/actions/lesson/LESSON_COPY"
import type Dispatcher from "cc-frontend/services/dispatcher"
import type ModalManager from "cc-frontend/services/modal-manager"
import type Session from "cc-frontend/services/session"
import moment from "moment"

@tagName("")
export default class LessonMenuPrimaryBodyReadOnly extends Component {
  lesson!: CardStack
  courseId!: string
  planbook!: Planbook
  dateString!: string
  closeMenu!: Function

  @service dispatcher!: Dispatcher
  @service session!: Session
  @service modalManager!: ModalManager

  @action
  copyLesson() {
    this.closeMenu()

    if (this.session.isAuthenticated !== true) {
      this.session.mustSignInToProceed("Copy Lesson")
      return
    }

    if (this.session.userId !== null) {
      this.dispatcher.dispatchPreparedAction(
        copyLessonAction({
          lessonToCopy: this.lesson,
          cardStackId: this.lesson.id,
          currentUserId: this.session.userId,
          ownerIds: [this.planbook.relationships.owner.data.id],
          planbookId: this.planbook.id,
          courseId: this.courseId,
        })
      )
    }
  }

  @action
  printOrDownload() {
    //pass in medium as param
    this.modalManager.openModal("planner/modals/print-download", {
      courseId: this.courseId,
      planbookId: this.planbook.id,
      startDate: this.dateString,
      endDate: this.dateString,
      layout: "course-date:single",
      currentUserId: this.session.userId,
      canPrint: true,
      dateRangeString: moment(this.dateString).format("dddd, MMMM Do YYYY"),
    })
    this.closeMenu()
  }
}
